import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ProductDetails from '../product-details';

class Component extends BaseComponent {
    componentDidMount() {
        this.props.requireState(this.props.upc);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.message != this.props.message) {
            return true;
        }

        if (nextProps.description != this.props.description) {
            return true;
        }

        if (nextProps.product != this.props.product) {
            return true;
        }

        return false;
    }

    render({ description, product }) {
        if (description) {
            const iconClass = `icon-${description.code}`;

            let buttonText = description.code == 'forecast-monthly-subscription'
                ? 'START MY MEMBERSHIP'
                : 'PURCHASE SUBSCRIPTION';

            return (
                <subscription-teeup>
                    <p className='price'>
                        {this.renderSalePrice()}
                        {this.renderPrice()}
                        {this.renderPriceValue()}
                    </p>
                    <header>
                        <div className={`icon-teeup ${iconClass}`} />
                        <h1 className='fancy-title'>{description.product_name}</h1>
                        <ProductDetails summary={description.subheader} details={description.long_description} />
                    </header>
                    {this.renderMessage()}
                    <form onSubmit={this.submit}>
                        <div className='has-text-center'>
                            <button className='button button-warning'>
                                {product.submitting ? 'submitting…' : buttonText}
                            </button>
                            {this.renderError()}
                        </div>
                    </form>
                </subscription-teeup>
            );
        }

        return (<subscription-teeup />);
    }

    renderSalePrice = () => {
        if (this.props.product.price && this.props.product.price.usd.current < this.props.product.price.usd.original) {
            return (<s>${this.props.product.price.usd.original.toFixed(2)}</s>);
        }

        return null;
    }

    renderPrice = () => {
        if (this.props.product.price) {
            return (<span>${this.props.product.price.usd.current.toFixed(2)} Per Month</span>);
        }

        return null;
    }

    renderPriceValue = () => {
        if (
            this.props.product.description
            &&
            this.props.product.description.code
            &&
            this.props.product.description.code == 'forecast-monthly-subscription'
        ) {
            return (<div className='has-text-center'>($20 Value!)</div>);
        }

        return null;
    }

    renderMessage = () => {
        if (this.props.message) {
            return (<div className='marketing-message' dangerouslySetInnerHTML={{__html: this.props.message}} />);
        }

        return null;
    }

    renderError = () => {
        if (this.props.product.error) {
            return (<p className='error'>{this.props.product.error}</p>);
        }

        return null;
    }

    submit = (e) => {
        e.preventDefault();
        this.props.submit();
    }
}

const mapStateToProps = (state) => ({
    message: state.product && state.product.marketing_message,
    description: state.product && state.product.description,
    product: state.product,
});

const mapDispatchToProps = (dispatch) => ({
    requireState: (upc) => dispatch({ type: 'subscription:init', payload: upc }),
    submit: () => dispatch({ type: 'product:submit' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);


